lmApp
  .service('ModalConfirmService', ['$rootScope', '$templateCache', '$compile', 'SupervisorService', 'ToastService',
    function ($rootScope, $templateCache, $compile, SupervisorService, ToastService) {

      var _onKeyDown = function (event) {
        var key = event.which;

        if (key === 27) {
          if (event.preventDefault) event.preventDefault();
          if (event.stopPropagation) event.stopPropagation();
          Close($rootScope.confirmScope, false);

          return;
        }
      };

      var _confirm = function () {
        $rootScope.confirmScope.error = false;
        $rootScope.confirmScope.loading = true;
        $rootScope.showLinearProgress('#confirmationLoader');

        SupervisorService.Check($rootScope.globals.currentUser.username, $rootScope.confirmScope.passCheck)
          .then(function () {
            $rootScope.confirmScope.passCheck = '';

            if ($rootScope.confirmScope.action.fn)
              $rootScope.confirmScope.action.fn();

            Close($rootScope.confirmScope, true);

            $rootScope.confirmScope.loading = false;
            $rootScope.hideLinearProgress('#confirmationLoader');
          })
          .catch(function () {
            $rootScope.confirmScope.passCheck = '';
            $rootScope.confirmScope.error = true;
            $rootScope.confirmScope.loading = false;
            $rootScope.hideLinearProgress('#confirmationLoader');
            ToastService.Small({
              title: 'Wrong confirmation',
              color: 'deep-orange',
              icon: 'alert-circle'
            })
          })
      };

      /**
       *
       * @param options {
       *     content: String,
       *     action: {
       *       title: String,
       *       color: String,
       *       fn: Function,
       *       show_fn: Function
       *     },
       *     onInit: Function
       *     onComplete: Function(result),
       *     size: {
       *       s: Number,
       *       m: Number,
       *       l: Number
       *     },
       *     isFixed: Boolean,
       *     fixedHeight: Boolean,
       *     keyboard: Boolean - close on keyboard events
       *     clear: Boolean - with out padding,
       *     mainFn: Function
       * @returns {*} $scope
       */
      var Open = function (options) {
        var modalScope = $rootScope.$new(false);

        modalScope.close = function () {
          Close(modalScope, false);
        };

        modalScope.confirm = _confirm;

        $rootScope.confirmScope = modalScope;

        modalScope.action = options.action;

        modalScope._confirm_element_ = $templateCache.get('lm-confirm-window/lm-confirm-window.tpl.html');

        modalScope._confirm_element_ = $compile(modalScope._confirm_element_)(modalScope);

        modalScope.overlay = angular.element('body').find('#lean-overlay');

        modalScope._confirm_element_.attr('id', 'id_' + Date.now());
        angular.element('#modal_container').append(modalScope._confirm_element_);

        angular.element('body').bind('keydown', _onKeyDown);

        if (options.size) modalScope.size = options.size;

        modalScope._confirm_element_.find('.modal-content').css({visibility: 'hidden'});
        if (options.content) {
          if (options.clear) {
            modalScope._confirm_element_.html(options.content);
          } else {
            modalScope._confirm_element_.find('.modal-content').html(options.content);
          }
        }

        if (options.keyboard) modalScope.isKeyevent = true;

        modalScope.clear = options.clear;

        if (options.onComplete) {
          modalScope.FinalCallback = options.onComplete;
        } else {
          modalScope.FinalCallback = function () {
          }
        }

        if (options.onInit) {
          modalScope.InitCallback = options.onInit;
        } else {
          modalScope.InitCallback = function () {
          }
        }

        if (options.isFixed) modalScope.isFixed = true;

        modalScope._confirm_element_.css({
          top: 10 - modalScope.depth * 2 + '%',
          'z-index': 1000
        });

        TweenMax
          .from(modalScope._confirm_element_, 0.35, {
            top: '0px',
            ease: Expo.easeInOut,
            onComplete: function () {

              modalScope._confirm_element_.css({
                top: 10 + '%',
                display: 'block'
              });

              modalScope._confirm_element_.find('.modal-content').css({visibility: 'visible'});

              modalScope.InitCallback();
            }
          });

        TweenMax
          .to(modalScope.overlay, 0.35, {
            display: 'block',
            opacity: 0.8,
            ease: Expo.easeInOut
          });

        modalScope.offset = window.pageYOffset;

        angular.element('body').css({
          position: 'fixed',
          width: '100%',
          top: -modalScope.offset + 'px'
        });
        return modalScope;
      };

      var Close = function (modalScope, result) {
        if (!modalScope || !modalScope._confirm_element_) return;

        TweenMax
          .to(modalScope._confirm_element_, 0.45, {
            top: '-10%',
            ease: Expo.easeInOut,
            onComplete: function () {
              modalScope._confirm_element_.remove();
              angular.element('body').unbind('keydown', _onKeyDown);
            }
          });

        TweenMax
          .to(modalScope.overlay, 0.35, {
            display: 'none',
            ease: Expo.easeInOut
          });

        angular.element('body').removeAttr('style');
        angular.element(window).scrollTop(modalScope.offset);

        modalScope.FinalCallback(!!result);
      };

      // Public API
      return {
        Open: Open,
        Close: Close
      }
    }]);
